import { getMoment } from '@/utils/index.js'

// 工单类型
// 转交状态
const transferStatus = [
  { value: '0', label: '未转交' },
  { value: '1', label: '已转交' }
]

// 工单状态映射值
const STATUSLIST = {
  WAITDISTRIBTION: 1, // 待分配
  PENDING: 100, // 待处理
  PROCESSING: 101, // 处理中
  FINISH: 200, // 已完成
  EXPIRED: 300, // 已过期
  INVALID: 400 // 已失效
}
// 工单状态
const workOrderStatus = [
  {
    label: '待处理',
    value: STATUSLIST.PENDING
  },
  {
    label: '处理中',
    value: STATUSLIST.PROCESSING
  },
  {
    label: '已完成',
    value: STATUSLIST.FINISH
  },
  {
    label: '已过期',
    value: STATUSLIST.EXPIRED
  },
  {
    label: '已失效',
    value: STATUSLIST.INVALID
  }
]
const autocompleteList = [
  { value: 1, label: '自动完成（无痕迹）' },
  { value: 3, label: '自动完成（有痕迹）' },
  { value: 6, label: '已失效（处理前）' },
  { value: 7, label: '已失效（处理后）' },
  { value: 4, label: '无' }
]
const finishLabelMap = {
  [STATUSLIST.WAITDISTRIBTION]: autocompleteList,
  [STATUSLIST.PENDING]: autocompleteList,
  [STATUSLIST.PROCESSING]: autocompleteList,
  [STATUSLIST.FINISH]: [
    {
      value: 5,
      label: '系统完成'
    },
    {
      value: 2,
      label: '健管完成'
    },
    // 6和7不要展示在已完成时候
    ...autocompleteList.filter(f => ![6, 7].includes(f.value))
  ],
  [STATUSLIST.INVALID]: [
    { value: 6, label: '已失效（处理前）' },
    { value: 7, label: '已失效（处理后）' }
  ]
}
const workOrderIsValid = [
  { label: '有效', value: 1 },
  { label: '无效', value: 0 }
]
const timesMap = [
  { value: 0, label: '0' },
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5次及5次以上' }
]
const statusLabelMap = [
  { value: 1, label: '未处理' },
  { value: 2, label: '未处理未完成' },
  { value: 3, label: '已处理未完成' }
]
const defaultQuery = {
  workOrderIdList: undefined,
  reminder: undefined,
  businessType: undefined,
  state: undefined,
  stateTag: undefined,
  transferFlag: undefined,
  acceptorName: undefined,
  isValid: undefined,
  createTime: getMoment(5), //创建时间
  allocateTime: [], //分配时间
  dealTime: [], //处理时间
  completeTime: [], //结束时间
  allocatedNumType: undefined,
  allocationFlag: undefined,
  allocateTag: undefined,
  belongUserErpSn: undefined,
  curPage: 1,
  pageSize: 10
}

const rangePresets = {
  今日: getMoment(1),
  本月: getMoment(2),
  上月: getMoment(3),
  近三月: getMoment(4)
}
export {
  transferStatus,
  workOrderStatus,
  workOrderIsValid,
  timesMap,
  statusLabelMap,
  defaultQuery,
  finishLabelMap,
  rangePresets
}
